export default "__VITE_ASSET__DCN7CRxP__"